// extracted by mini-css-extract-plugin
export default {"card":"PasscodeVerification_card__EQU0L","form":"PasscodeVerification_form__D+Cj-","title":"PasscodeVerification_title__xpVJM","info":"PasscodeVerification_info__qmOyt"};